import { createAction, props } from '@ngrx/store';
import { Profession } from '@planone/bau365/util-fair-data';

export const professionsLoadSucceeded = createAction(
  '[Profession API] Professions load succeeded',
  props<{ professions: Profession[] }>()
);

export const professionsLoadFailed = createAction(
  '[Profession API] Professions load failed',
  props<{ error: string }>()
);
